import { render, staticRenderFns } from "./403.vue?vue&type=template&id=572a8552"
var script = {}
import style0 from "./403.vue?vue&type=style&index=0&id=572a8552&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports